
export default class Address {
	id: number;             //ид
	cityId: number;         //ид города
	city: string;           //город
	streetId: number;       //ид улицы
	street: string;         //улица
	homeNumber: string;     //номер дома
}